<template lang="pug">
  v-list-item(@click="$refs.inputUpload.click()")
    v-list-item-title {{title}}
    input( v-show="false" ref="inputUpload" type="file" @change='inputImage' accept='image/*')    
</template>
<script>
import {storage} from '@/FirebaseConfig'
import { watch } from 'fs';
export default {
  data: ()=>({
    value: '',
    imageFile: '',
    updateState: null
  }),
  props: {
    title: String,
  },
  methods: {
    onClickButton (value) {
      this.$emit('getUrl', value)
    },
    inputImage(event){
      let image = this.imageFile=event.target.files[0]
      let _this=this
      let uploadTask = storage.ref(`/images/${image.name}`).put(image)
      uploadTask.on('state_changed', function(snapshot){
        _this.updateState = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      }, function(error) {
        console.log(error)
      }, function() {
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          _this.updateState = downloadURL
          
        })
      })
    }
    
  },
  watch:{
    'updateState'(){
      this.$emit('getUrl', this.updateState);
    }
  }
}
</script>

